export type ModuleServerData = {
  type: "remote" | "local";
  id: string;
  name: string;
  source?: string;
  authenticated?: boolean;
};

export type ModuleServerType = {
  id: string;
  name: string;
  type: "local" | "remote";
  authenticated: boolean;
};

export type ModuleData = {
  id: string;
  versions?: ModuleVersionData[];
  currentVersion?: string | undefined;
};

export type ModuleActionType =
  | "install"
  | "restore"
  | "update"
  | "not-installable"
  | "incompatible";

export type ModuleFilterType = "browse" | "installed" | "updates";

export type ModulePropertyData = {
  name: string;
  value?: string | string[];
  inline?: boolean;
};

export type ModuleServerFullData = ModuleServerData & {
  user?: string;
  password?: string;
};

export type ModuleVersionData = {
  id: string;
  name: string;
  description?: string;
  action: ModuleActionType;
  properties?: ModulePropertyData[];
  warningMessage?: string;
};

export type ExtendedModuleData = ModuleData & {
  selectedVersion: ModuleVersionData;
};

export type EditServerModuleResult = {
  success: boolean;
  message: string;
};
